import ReauthenticateCode from "./ReauthenticateCode";

export default function ReauthenticateTOTP (props) {
  return (
    <ReauthenticateCode>
      <p>Please enter an authenticator code:</p>
    </ReauthenticateCode>
  );
}
